/* eslint-disable indent */
import { Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { LeakedCredentialResetStatus } from 'modules/partners/interfaces';
import i18n from 'i18n';
import { formatDateWithMoment } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

const STATUS_I18N: Record<LeakedCredentialResetStatus, string> = {
  pending: 'LEAKED_CREDENTIALS_STATUS_PENDING_KEY',
  admin_reset: 'LEAKED_CREDENTIALS_STATUS_ADMIN_RESET_KEY',
  user_recovered: 'LEAKED_CREDENTIALS_STATUS_USER_RECOVERED_KEY',
};

const TOOLTIP_I18N: Record<LeakedCredentialResetStatus, string> = {
  pending: 'LEAKED_CREDENTIALS_STATUS_PENDING_TOOLTIP_KEY',
  admin_reset: 'LEAKED_CREDENTIALS_STATUS_ADMIN_RESET_TOOLTIP_KEY',
  user_recovered: 'LEAKED_CREDENTIALS_STATUS_USER_RECOVERED_TOOLTIP_KEY',
};

interface CredentialPhaseStatusProps {
  status: LeakedCredentialResetStatus;
  password_reset_by_user_at?: string | null;
}

const CredentialPhaseStatus = ({
  status,
  password_reset_by_user_at,
}: CredentialPhaseStatusProps) => {
  const classes = useStyles();

  const getIndicatorClass = () => {
    switch (status) {
      case 'pending':
        return classes.indicatorRed;
      case 'admin_reset':
        return classes.indicatorYellow;
      case 'user_recovered':
        return classes.indicatorGreen;
      default:
        return classes.indicatorRed;
    }
  };

  const label = i18n.t(STATUS_I18N[status]);
  const infoTooltipTitle = i18n.t(TOOLTIP_I18N[status]);
  const tooltipTitle =
    status === 'user_recovered' && password_reset_by_user_at ? (
      <>
        <div>{infoTooltipTitle}</div>
        <div>
          {i18n.t('LEAKED_CREDENTIALS_USER_RESET_AT_KEY')}:{' '}
          {formatDateWithMoment(password_reset_by_user_at)}
        </div>
      </>
    ) : (
      infoTooltipTitle
    );

  return (
    <Grid
      container
      alignItems="center"
      wrap="nowrap"
      className={classes.indicatorRow}
    >
      <div className={classes.statusLabelGroup}>
        <span
          className={getIndicatorClass()}
          style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            minWidth: 8,
            borderRadius: 4,
            flexShrink: 0,
            marginRight: 8,
          }}
        />
        <Typography className={classes.statusLabel} variant="body2">
          {label}
        </Typography>
      </div>
      <Tooltip title={tooltipTitle} arrow placement="top">
        <InfoOutlinedIcon
          className={classes.infoIcon}
          fontSize="small"
          color="action"
        />
      </Tooltip>
    </Grid>
  );
};

export default CredentialPhaseStatus;
